import React from 'react';
import LineDropdownSelector from '../LineDropdownSelector/LineDropdownSelector';
import styles from './LineSelector.module.css';

const LineSelector = ({ hasActiveEdits, props }) => {
  return (
    <>
      <div className={styles.selectorSmall}>
        <span className={styles.captionSmall}> Select line(s)</span>
      </div>
      <div className={styles.selectorBt}>
        <LineDropdownSelector
          hasActiveEdits={hasActiveEdits}
          className={styles.optiontxt}
        />
      </div>
    </>
  );
};

LineSelector.propTypes = {};

export default LineSelector;
